import {
    type GetSectorsResponseType
} from "./type";
import {
    request
} from "../request";

const getSectors = async (): Promise<GetSectorsResponseType> => {
    return await request<GetSectorsResponseType>("/staticData/getSectors", {
        method: "GET"
    });
};
export default getSectors;
